import { OptionData } from '../../../components/displays/newTradingInterface/tradingModule/components/options/optionChains/optionType';
import { OptionManagement } from './optionManagement';
type SelectedOptions = {
  [key: string]: string[];
};

type ValidOptions = {
  [key: string]: OptionData;
};
export const returnValidOptions = (root: OptionManagement) => {
  const selectedOptions: SelectedOptions | {} = {};
  const keyValuePair = Object.entries(root.optionChainSelectionMap);

  keyValuePair.forEach(([date, symbolObj]) => {
    selectedOptions[date] = Object.keys(symbolObj).filter(
      (symbol) => root.optionChainSelectionMap[date][symbol]
    );
  });

  const validOptions: ValidOptions = {};
  const quantityBasis: string = root.tradePlanForm.quantityBasis;
  const quantityBasisValue: number =
    root.tradePlanForm.currentQuantityBasisValue;
  const direction: 'NONE' | 'LONG' | 'SHORT' | 'BOTH' =
    root.tradePlanForm.direction;
  const optionDirection: string = root.buyOrSellOption;

  if (root.optionChainStrategyString === 'TIGHTEST_SPREAD') {
    const dates = Object.keys(selectedOptions);
    dates.forEach((date) => {
      selectedOptions[date].forEach((symbol: string) => {
        validOptions[symbol] = root.optionDataReferenceMap[symbol];
      });
    });
  } else if (
    root.optionChainStrategyString === 'OTM1' &&
    root.underlyingPrice
  ) {
    const otmArr = [];
    const dates = Object.keys(root.optionChains);
    if (direction === 'NONE' || direction === 'BOTH' || direction === 'LONG') {
      if (optionDirection === 'LONG') {
        dates.forEach((date) => {
          const lengthOfChains = root.optionChains[date]?.calls?.length ?? 0;
          for (let i = 0; i < lengthOfChains - 1; i++) {
            const { symbol, strike } = root.optionChains[date]?.calls[i];
            if (strike > root.underlyingPrice) {
              otmArr.push(symbol);
              break;
            }
          }
        });
      } else {
        dates.forEach((date) => {
          const lengthOfChains = root.optionChains[date]?.puts?.length ?? 0;
          for (let i = lengthOfChains - 1; i >= 0; i--) {
            const { symbol, strike } = root.optionChains[date]?.puts[i];
            if (strike < root.underlyingPrice) {
              otmArr.push(symbol);
              break;
            }
          }
        });
      }
    }
    if (direction === 'NONE' || direction === 'BOTH' || direction === 'SHORT') {
      if (optionDirection === 'LONG') {
        dates.forEach((date) => {
          const lengthOfChains = root.optionChains[date]?.puts?.length ?? 0;
          for (let i = lengthOfChains - 1; i >= 0 - 1; i--) {
            const { symbol, strike } = root.optionChains[date]?.puts[i];
            if (strike < root.underlyingPrice) {
              otmArr.push(symbol);
              break;
            }
          }
        });
      } else {
        dates.forEach((date) => {
          const lengthOfChains = root.optionChains[date]?.calls?.length ?? 0;
          for (let i = 0; i < lengthOfChains - 1; i++) {
            const { symbol, strike } = root.optionChains[date]?.calls[i];
            if (strike > root.underlyingPrice) {
              otmArr.push(symbol);
              break;
            }
          }
        });
      }
    }
    dates.forEach((date) => {
      selectedOptions[date].forEach((symbol: string) => {
        if (otmArr.includes(symbol)) {
          validOptions[symbol] = root.optionDataReferenceMap[symbol];
        }
      });
    });

    // iterate through each date's options from index 0 to end and find the strike price right above the current underlying price. Opposite for short, do same for each date and save each option that matches
  } else if (
    root.optionChainStrategyString === 'ITM1' &&
    root.underlyingPrice
  ) {
    const itmArr = [];

    const dates = Object.keys(root.optionChains);
    if (direction === 'NONE' || direction === 'BOTH' || direction === 'LONG') {
      if (optionDirection === 'LONG') {
        dates.forEach((date) => {
          const lengthOfChains = root.optionChains[date]?.calls?.length ?? 0;
          for (let i = lengthOfChains - 1; i >= 0; i--) {
            const { strike } = root.optionChains[date]?.calls[i];
            if (strike < root.underlyingPrice) {
              itmArr.push(root.optionChains[date]?.calls[i]?.symbol);
              break;
            }
          }
        });
      } else {
        dates.forEach((date) => {
          const lengthOfChains = root.optionChains[date]?.puts?.length ?? 0;
          for (let i = 0; i < lengthOfChains - 1; i++) {
            const { strike } = root.optionChains[date]?.puts[i];
            if (strike > root.underlyingPrice) {
              itmArr.push(
                itmArr.push(root.optionChains[date]?.puts[i]?.symbol)
              );
              break;
            }
          }
        });
      }
    }
    if (direction === 'NONE' || direction === 'BOTH' || direction === 'SHORT') {
      if (optionDirection === 'LONG') {
        dates.forEach((date) => {
          const lengthOfChains = root.optionChains[date]?.puts?.length ?? 0;
          for (let i = 0; i < lengthOfChains - 1; i++) {
            const { strike } = root.optionChains[date]?.puts[i];
            if (strike > root.underlyingPrice) {
              itmArr.push(
                itmArr.push(root.optionChains[date]?.puts[i]?.symbol)
              );
              break;
            }
          }
        });
      } else {
        dates.forEach((date) => {
          const lengthOfChains = root.optionChains[date]?.calls?.length ?? 0;
          for (let i = lengthOfChains - 1; i >= 0; i--) {
            const { strike } = root.optionChains[date]?.calls[i];
            if (strike < root.underlyingPrice) {
              itmArr.push(root.optionChains[date]?.calls[i]?.symbol);
              break;
            }
          }
        });
      }
    }
    dates.forEach((date) => {
      selectedOptions[date].forEach((symbol: string) => {
        if (itmArr.includes(symbol)) {
          validOptions[symbol] = root.optionDataReferenceMap[symbol];
        }
      });
    });
  }
  const resultObj = {};

  Object.values(validOptions).forEach((option: OptionData) => {
    let passes = true;
    if (root.optionFilters.tightSpreadPct) {
      const spread = root.optionFilterDetails.tightSpreadPct.maxOptionSpreadPct;
      const optionSpread =
        (Number(Number(option.ask)) - Number(Number(option.bid))) /
        Number(Number(option.ask));
      if (optionSpread > spread) passes = false;
    }
    if (root.optionFilters.tightSpreadCents) {
      const cents =
        root.optionFilterDetails.tightSpreadCents.maxOptionSpreadCents;
      const optionCents = Number(option.ask) - Number(option.bid);
      if (optionCents > cents) {
        passes = false;
      }
    }
    if (root.optionFilters.optionPriceRange) {
      const mid = (Number(option.bid) + Number(option.ask)) / 2;
      const minPrice = root.optionFilterDetails.optionPriceRange.minPrice;
      const maxPrice = root.optionFilterDetails.optionPriceRange.maxPrice;
      if (mid <= minPrice || mid >= maxPrice) {
        passes = false;
      }
    }
    if (quantityBasis === 'DOLLARS' && root.optionFilters.qtyRange) {
      const min = root.optionFilterDetails.qtyRange.minQty;
      const max = root.optionFilterDetails.qtyRange.maxQty;
      const mid = (Number(option.bid) + Number(option.ask)) / 2;
      const expectedQty = quantityBasisValue / mid / 100;
      if (expectedQty <= min || expectedQty >= max) {
        passes = false;
      }
    }
    if (quantityBasis === 'QUANTITY' && root.optionFilters.dollarRange) {
      const min = root.optionFilterDetails.dollarRange.minDollar;
      const max = root.optionFilterDetails.dollarRange.maxDollar;
      const mid = (Number(option.bid) + Number(option.ask)) / 2;
      const expectedDollar = quantityBasisValue * mid * 100;
      if (expectedDollar <= min || expectedDollar >= max) {
        passes = false;
      }
    }
    if (passes && option?.symbol) resultObj[option.symbol] = option;
  });
  if (quantityBasis === 'DOLLARS') {
    const symbols = Object.keys(resultObj);
    symbols.forEach((symbol) => {
      const option: OptionData = resultObj[symbol];
      const mid = (Number(option.ask) + Number(option.bid)) / 2;
      if (mid * 100 > quantityBasisValue) delete resultObj[symbol];
    });
  }
  return resultObj;
};
